export { default } from './PDPView'
export * from './PDPView'
